<template>
  <main class="home">
    <section class="hero">
      <h1>Becca & Dylan</h1>
      <p class="body-md body-md--light">October 5, 2024</p>
      <p class="body-md body-md--light">Saugerties, New York</p>
    </section>

    <v-nav/>

    <section class="wedding-date">
      <div class="left"></div>
      <div class="mid">
        <p>10</p>
        <p>05</p>
        <p>24</p>
      </div>
      <div class="right"></div>
    </section>

    <section class="padded-lg names">
      <h2>
        Rebekah Sunmi Lee Bae
        <br>
        &
        <br>
        Dylan Wadsworth M<span class="lowercase">c</span>Carthy
      </h2>
    </section>

    <section class="padded-lg card-row">
      <div class="card card--one">
        <div class="details">
          <p class="body-md body-md--light">January 2018</p>
          <p class="subheading-display">First Date</p>
          <p class="body-md body-md--light">
            Cafe Colette
            <br>
            Brooklyn, NY
          </p>
        </div>
      </div>
      <div class="card card--two">
        <div class="details">
          <p class="body-md body-md--light">October 2022</p>
          <p class="subheading-display">Proposal</p>
          <p class="body-md body-md--light">
            Casa Malí
            <br>
            Mexico City, MX
          </p>
        </div>
      </div>
      <div class="card card--three">
        <div class="details">
          <p class="body-md body-md--light">October 2024</p>
          <p class="subheading-display">Wedding</p>
          <p class="body-md body-md--light">
            SPAF
            <br>
            Saugerties, NY
          </p>
        </div>
      </div>
    </section>
  </main>
</template>


<script>
import Nav from '@/components/Nav'

export default {
  components: {
    'v-nav': Nav
  }
}
</script>

<style lang="scss" scoped>
  .hero {
    background-image: url('~@/assets/img/home-01.jpg');
    background-position: center;
    background-size: cover;
    align-items: center;
    color: $color-shade-100;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 0;
    min-height: 240px;
    padding: $space-6;
    text-align: center;

    @include min-width(tablet) {
      min-height: 390px;
    }

    @include min-width(desktop) {
      min-height: 700px;
    }

    .body-md.body-md--light {
      letter-spacing: .9px;
      margin: calc(#{$space-1}/6);

      @include min-width(tablet) {
        font-size: 18px;
        letter-spacing: 1.4px;
        margin: calc(#{$space-1}/2);
      }
    }
  }

  .wedding-date {
    align-items: stretch;
    display: flex;
    justify-content: space-between;
    min-height: 240px;
    width: 100%;

    @include min-width(tablet) {
      min-height: 460px;
    }

    @include min-width(desktop) {
      min-height: 825px;
    }

    .left, .right {
      background-position: center;
      background-size: cover;
    }

    .left {
      background-image: url('~@/assets/img/home-02.jpg');
      flex: 2;
    }

    .mid {
      align-items: center;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;

      @include min-width(tablet) {
        flex: 1.5;
      }
    }

    .right {
      background-image: url('~@/assets/img/home-03.jpg');
      flex: 1;
    }

    p {
      @extend %page-heading;
      margin: 0;
      text-align: center;

      @include min-width(tablet) {
        margin: 0 $space-10;
      }

      &+p {
        border-top: $border-900-sm;
      }
    }
  }

  .names {
    background-color: $color-shade-900;
    color: $color-shade-100;
    text-align: center;
  }

  .card-row {
    display: flex;
    flex-direction: column;

    @include min-width(tablet) {
      flex-direction: row;
      gap: $space-2;
    }

    @include min-width(desktop) {
      gap: $space-4;
    }

    @include min-width(lg) {
      gap: $space-6;
    }

    .card {
      background-position: center;
      background-size: cover;
      flex: 1;

      &--one {
        background-image: url('~@/assets/img/home-04.jpg');
      }

      &--two {
        background-image: url('~@/assets/img/home-05.jpg');
      }

      &--three {
        background-image: url('~@/assets/img/home-06.jpg');
      }

      .details {
        align-items: center;
        background-color: rgba(250, 250, 250, .85);
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: $space-3;
        margin: $space-3;
        text-align: center;

        @include min-width(desktop) {
          padding: $space-4;
          margin: $space-4;
        }

        @include min-width(lg) {
          padding: $space-5;
          margin: $space-6;
        }

        h3 {
          margin: $space-2 0;
        }
      }
    }
  }
</style>